import { render, staticRenderFns } from "./ColumnSelect.vue?vue&type=template&id=197a9bfa&scoped=true&"
import script from "./ColumnSelect.vue?vue&type=script&lang=ts&"
export * from "./ColumnSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnSelect.vue?vue&type=style&index=0&id=197a9bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a9bfa",
  null
  
)

export default component.exports